import { useEffect, useRef } from "react"
import { CylinderMaterial } from "./CylinderMaterial"

export default function Cylinder() {
    return (
        <mesh rotation={[0, Math.PI * 0.5, Math.PI * 0.5]} position={[0,0,-1]}>
            <cylinderGeometry args={[5, 5, 40, 64, 1, false]} />
            <CylinderMaterial />
        </mesh>
    )
} 